import classNames from 'classnames';
import exact from 'prop-types-exact';
import PropTypes from 'prop-types';
import React from 'react';

const propTypes = exact({
  blockName: PropTypes.string,
  fieldName: PropTypes.string,
  fieldValue: PropTypes.string,
  handleChange: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool,
  isInvalid: PropTypes.bool,
  isRequired: PropTypes.bool,
  isValid: PropTypes.bool,
  modifier: PropTypes.string,
  placeholderText: PropTypes.string,
});

const defaultProps = {
  blockName: null,
  fieldName: null,
  fieldValue: '',
  isDisabled: false,
  isInvalid: false,
  isRequired: false,
  isValid: false,
  modifier: 'ghost',
  placeholderText: null,
};

function Textarea(props) {
  const textareaClasses = classNames(props.blockName, 'Textarea', `Textarea-${props.modifier}`, {
    disabled: props.isDisabled,
    invalid: props.isInvalid,
    valid: props.isValid,
  });

  return (
    <textarea
      name={props.fieldName}
      value={props.fieldValue}
      disabled={props.isDisabled}
      required={props.isRequired}
      onChange={props.handleChange}
      placeholder={`${props.placeholderText}${props.isRequired ? '*' : ''}`}
      className={textareaClasses}
    />
  );
}

Textarea.propTypes = propTypes;
Textarea.defaultProps = defaultProps;

export default Textarea;
